<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="width"
      @close="dialogClose"
      @open="dialogOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50vh"
      class="myDialog detailDialog"
      v-dialogDrag
    >
      <el-dialog
        width="460px"
        title="修改销售订单"
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="myDialog"
        top="50vh"
        v-dialogDrag
      >
        <el-form
          :model="editDetailForm"
          :rules="editDetailRules"
          ref="editDetailForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="销售单号" size="small" prop="orderNumber">
            <el-input v-model="editDetailForm.orderNumber" placeholder="ERP里的销售单号" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="客户PO" size="small" prop="customerPo">
            <el-input v-model="editDetailForm.customerPo" placeholder="输入客户PO" clearable></el-input>
          </el-form-item>
          <el-form-item label="销售人员" size="small">
            <el-select
              v-model="editDetailForm.salesId"
              placeholder="选择销售人员"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'sales', '员工选择')"
            >
              <el-option
                v-for="(item, index) in pullDownData.salesAddList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" size="small">
            <el-date-picker
              v-model="editDetailForm.orderDate"
              type="date"
              placeholder="下单时间"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" size="small">
            <el-input
              type="textarea"
              :rows="2"
              v-model="editDetailForm.notes"
              placeholder="备注信息"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('editDetailForm')" size="small">取消</el-button>
          <el-button type="primary" @click="submitForm('editDetailForm')" size="small">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog
          class="myDialog checkProduct"
          width="500px"
          top="50vh"
          title="新增组装工单"
          :visible.sync="productionOrderVisible"
          append-to-body
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="closeCheckProduct"
          v-dialogDrag
        >
          <el-steps
            class="productSteps"
            :active="productPagenum"
            finish-status="success"
            align-center
          >
            <el-step title="产品型号" @click.native="stepClick(0)"></el-step>
            <el-step title="基本信息" @click.native="stepClick(1)"></el-step>
            <el-step title="生产信息" @click.native="stepClick(2)"></el-step>
            <el-step title="扩展信息" @click.native="stepClick(3)"></el-step>
            <el-step title="版本信息" @click.native="stepClick(4)"></el-step>
            <el-step title="校验信息" @click.native="stepClick(5)"></el-step>
          </el-steps>
          <el-form
            ref="productForm"
            :model="productForm"
            :rules="productRules"
            label-width="80px"
            class="demo-ruleForm"
          >
            <div v-if="productPagenum == 0" key="1">
              <el-form-item label="产品类别" size="small" prop="productType">
                <el-select
                  v-model="productForm.productType"
                  placeholder="选择产品类别"
                  filterable
                  clearable
                  @change="addProductTypeChange"
                  :disabled="isEditProduct"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.productTypeList"
                    :key="index"
                    :label="item.title"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产品型号" size="small" prop="productId">
                <el-select
                  v-model="productForm.productId"
                  placeholder="选择产品型号"
                  filterable
                  clearable
                  @change="productIdChange"
                  :disabled="isEditProduct"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.addProductList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单数量" size="small" prop="quantity">
                <el-input
                  :value="productForm.quantity"
                  @input="$event => $set(productForm, 'quantity', $event.replace(/[^\d]/g,'').replace(/^0{1,}/g,''))"
                  placeholder="下单数量"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="成品编码" size="small" prop="itemCode">
                <el-input v-model="productForm.itemCode" placeholder="ERP里的成品编码" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 1" key="2">
              <el-form-item label="自定义型号" size="small" prop="customerModel">
                <el-input v-model="productForm.customerModel" placeholder="客户自定义型号" clearable></el-input>
              </el-form-item>
              <el-form-item label="自定义版本" size="small" prop="customerEdition">
                <el-input v-model="productForm.customerEdition" placeholder="客户自定义版本" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品规格" size="small" prop="gauge">
                <el-input v-model="productForm.gauge" placeholder="产品规格" clearable></el-input>
              </el-form-item>
              <el-form-item label="PID" size="small" prop="tuyaPid">
                <el-input v-model="productForm.tuyaPid" placeholder="产品PID（涂鸦PID或其他客户定义的PID）" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 2" key="3">
              <el-form-item label="SN模版" size="small" prop="snPrefix">
                <el-input
                  class="inlineItem"
                  v-model="productForm.snPrefix"
                  placeholder="输入SN模版"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
                <el-checkbox class="inlineItem" v-model="productForm.createSn" @change="createSnChange">创建时生成SN</el-checkbox>
              </el-form-item>
              <el-form-item label="流水长度" size="small" prop="snLen">
                <el-input
                  class="inlineItem"
                  :value="productForm.snLen"
                  @input="onlyNumber($event, 'productForm', 'snLen')"
                  placeholder="SN流水号长度"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
                <el-checkbox class="inlineItem" v-model="productForm.onlyCarton">只使用包装流程</el-checkbox>
              </el-form-item>
              <el-form-item label="起始SN" size="small" prop="startSn">
                <el-input
                  :value="productForm.startSn"
                  @input="onlyNumber($event, 'productForm', 'startSn')"
                  placeholder="输入起始SN"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
              </el-form-item>
              <el-form-item label="厂商信息" size="small" prop="vendor">
                <el-input v-model="productForm.vendor" placeholder="输入厂商信息" clearable></el-input>
              </el-form-item>
              <el-form-item label="默认密码" size="small" prop="defaultPassword">
                <el-input v-model="productForm.defaultPassword" placeholder="输入默认密码" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 3" key="4">
              <el-form-item label="客户料号" size="small" prop="partNumber">
                <el-input v-model="productForm.partNumber" placeholder="输入客户料号" clearable></el-input>
              </el-form-item>
              <el-form-item label="国家码" size="small" prop="countryCode">
                <el-input v-model="productForm.countryCode" placeholder="输入国家码" clearable></el-input>
              </el-form-item>
              <el-form-item label="EAN码" size="small" prop="eanCode">
                <el-input v-model="productForm.eanCode" placeholder="输入EAN码" clearable></el-input>
              </el-form-item>
              <el-form-item label="CMIIT ID" size="small" prop="cmiitId">
                <el-input v-model="productForm.cmiitId" placeholder="输入CMIIT ID" clearable></el-input>
              </el-form-item>
              <el-form-item v-show="p2pType == 'DLink'" label="检料单号" size="small" prop="pickSlip">
                <el-input v-model="productForm.pickSlip" placeholder="输入检料单号" clearable></el-input>
              </el-form-item>
              <el-form-item v-show="p2pType == 'DLink'" label="客户PO" size="small" prop="hqPo">
                <el-input v-model="productForm.hqPo" placeholder="客户的订单号" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 4" key="5">
              <el-form-item label="固件版本" size="small" prop="fwVersion">
                <el-input v-model="productForm.fwVersion" placeholder="如:V1.0.1" clearable></el-input>
              </el-form-item>
              <el-form-item label="硬件版本" size="small" prop="hwVersion">
                <el-input v-model="productForm.hwVersion" placeholder="如:V2020.08.13" clearable></el-input>
              </el-form-item>
              <el-form-item label="配置版本" size="small" prop="cfgVersion">
                <el-input v-model="productForm.cfgVersion" placeholder="如:V1.001" clearable></el-input>
              </el-form-item>
              <el-form-item label="系统版本" size="small" prop="osVersion">
                <el-input v-model="productForm.osVersion" placeholder="如:Android 7.0.1" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 5" key="6">
              <el-form-item label="吞吐量" size="small" prop="bandwidth">
                <el-input
                  :value="productForm.bandwidth"
                  @input="onlyDecimals($event, 'productForm', 'bandwidth')"
                  placeholder="吞吐量带宽(单位：Mbps，精确度0.1)"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="蓝牙名称" size="small" prop="btName">
                <el-input v-model="productForm.btName" placeholder="如:Mixcder E9" clearable></el-input>
              </el-form-item>
              <el-form-item label="最低电量" size="small" prop="minBatt">
                <el-input
                  :value="productForm.minBatt"
                  @input="minBattInput($event, 'productForm', 'minBatt')"
                  placeholder="输入最低电量"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item v-show="wakeup" label="电池容量" size="small" prop="battery">
                <el-input
                  :value="productForm.battery"
                  @input="batteryInput($event, 'productForm', 'battery')"
                  placeholder="输入电池容量"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button
              class="preButton"
              v-show="productPagenum > 0"
              @click="preProductPage"
              size="small"
            >上一步</el-button>
            <el-button
              class="nextButton"
              v-show="productPagenum < 5"
              @click="nextProductPage"
              size="small"
            >下一步</el-button>
            <el-button
              class="okButton"
              v-show="productPagenum >= 2"
              type="primary"
              @click="checkProductSubmit"
              size="small"
            >完 成</el-button>
          </span>
      </el-dialog>

      <ul class="ulBox clearFloat">
        <li>
          <div class="left">销售单号：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.orderNumber">{{orderDetailData.orderNumber}}</span>
            <span class="noValue" v-else>-</span>
            <i class="el-icon-edit allowSkip" 
              @click="editOrderNumber()"
            ></i>
          </div>
        </li>
        <li>
          <div class="left">客户：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.customer">{{orderDetailData.customer.name}}</span>
            <span class="noValue" v-else>无</span>
          </div>
        </li>
        <li>
          <div class="left">客户PO：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.customerPo">{{orderDetailData.customerPo}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">销售员：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.sales">{{orderDetailData.sales.name}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">产品数量：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.quantity">{{orderDetailData.quantity}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">下单时间：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.orderDate">{{orderDetailData.orderDate}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">产品列表：</div>
          <div  class="right">
            <el-button size="small" @click="productionOrderBtn">新增组装工单</el-button>
          </div>
        </li>
        <li class="blockLi">
          <div class="right">
            <el-table
              stripe
              :data="orderDetailData.productionOrders"
              class="productTable"
              border
              style="width: 100%"
              size="mini"
            >
              <el-table-column prop="orderNumber" label="组装工单" align="center" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.orderNumber">{{scope.row.orderNumber}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="product" label="型号" align="center" min-width="110" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.product">{{scope.row.product.code}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="itemCode" label="成品编码" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.itemCode">{{scope.row.itemCode}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="p2pType" label="Key类型" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.p2pType">{{scope.row.p2pType.title}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" label="数量" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.quantity">{{scope.row.quantity}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="95px" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status" class="textOverflow">{{scope.row.status.title}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">备注：</div>
          <div class="right">
            <span class="value" v-if="orderDetailData.notes">{{orderDetailData.notes}}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateDetailBtn">修改</el-button>
      </div>
    </el-dialog>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
  </div>
</template>

<script>
import {
  apiCustomerOrderDetail,
  apiCustomerOrderUpdateOrderNumber,
  apiCustomerOrderUpdate,
  apiProductTypeList,
  apiProductList,
  apiAddProductionOrder,
} from "@/api/customerOrder.js";
import orderTableSelect from "@/components/orderTableSelect.vue";
export default {
  props: {
    title: {
      type: String
    },
    width: {
      type: String,
      default: "850px"
    },
    nowRowData: {
      type: Object
    }
  },
  components: {
    orderTableSelect
  },
  data() {
    return {
      dialogVisible: false,
      orderDetailData: {},
      innerVisible: false,
      productionOrderVisible:false,
      editDetailForm: {},
      productPagenum: 0,
      isEditProduct: false,
      productForm: {
        snPrefix: "AONI_",
        snLen: 5,
        startSn: 1,
        onlyCarton: false,
        createSn: true
      },
      wakeup: false,
      p2pType: "",
      editDetailRules: {
        orderNumber: [
          { required: true, message: "销售单号不能为空！", trigger: "blur" },
          { min: 4, max: 64, message: "长度在 4 到 64 个字符", trigger: "blur" }
        ]
      },
      productRules: {
        orderNumber:[
          { required: true, message: "组装单号不能为空！", trigger: "blur" }
        ],
        productType: [
          { required: true, message: "产品类别不能为空！", trigger: "change" }
        ],
        productId: [
          { required: true, message: "产品型号不能为空！", trigger: "change" }
        ],
        quantity: [
          { required: true, message: "下单数量不能为空！", trigger: "blur" }
        ],
        itemCode: [
          { required: true, message: "成品编码不能为空！", trigger: "blur" },
          { min: 4, max: 64, message: "成品编码长度在4~64字符之间！", trigger: "blur" }
        ],
        customerModel: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        customerEdition: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        gauge: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        tuyaPid: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        snPrefix: [
          { min: 1, max: 64, message: "长度在 1 到 64 个字符", trigger: "blur" }
        ],
        // snLen: [
        //   { required: true, message: "SN流水号不能为空！", trigger: "blur" }
        // ],
        // startSn: [
        //   { required: true, message: "起始SN不能为空！", trigger: "blur" }
        // ],
        countryCode: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        eanCode: [
          { min: 9, max: 13, message: "长度在 9 到 13 个字符", trigger: "blur" }
        ],
        cmiitId: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        partNumber: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        pickSlip: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        hqPo: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        fwVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        hwVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        cfgVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        btName: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ]
      },
      pullDownData: {
        customerList: [],
        productTypeList: [],
        productList: [],
        addProductList: [],
        statusList: [],
        salesAddList: [],
      }
    };
  },
  methods: {
    // 详情对话框打开
    async dialogOpen() {
      this.orderDetailData = {};
      const res = await apiCustomerOrderDetail({
        id: this.nowRowData.id
      });
      if (res.code == 0) {
        this.orderDetailData = res.data;
      }
    },
    editOrderNumber() {
      const h = this.$createElement;
      var orderNumber = "";
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入新的销售单号:`
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputValue: this.orderDetailData.orderNumber,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            orderNumber = instance.inputValue;
          }
          done();
        },
      }).then(async () => {
        const res = await apiCustomerOrderUpdateOrderNumber({
          id: this.nowRowData.id,
          orderNumber
        });
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.orderDetailData.orderNumber = orderNumber;
        }
      });
    },
    dialogClose() {
      document.querySelectorAll(".el-dialog").forEach(item => {
        setTimeout(() => {
          item.style.left = "0";
          item.style.top = "0";
        }, 500);
      });
      this.$parent.getCustomerOrderSearch();
    },
    // 修改详情按钮
    updateDetailBtn() {
      this.innerVisible = true;
      this.editDetailForm = {
        id: this.orderDetailData.id,
        orderNumber: this.orderDetailData.orderNumber,
        customerPo: this.orderDetailData.customerPo,
        salesId: this.orderDetailData.sales.id,
        orderDate: this.orderDetailData.orderDate,
        notes: this.orderDetailData.notes
      };
      this.$set(this.pullDownData, "salesAddList", [
        this.orderDetailData.sales
      ]);
    },
    // 新增组装工单
    productionOrderBtn() {
      this.productionOrderVisible = true;
      this.isEditProduct = false;
      this.callback();
      this.productForm = {
        customerOrderId: this.orderDetailData.id,
        p2pType:this.orderDetailData.productionOrders[0].p2pType,
        productType:this.orderDetailData.productionOrders[0].productType.code,
        productId:this.orderDetailData.productionOrders[0].product.id,
        itemCode:this.orderDetailData.productionOrders[0].itemCode,
        snPrefix:this.orderDetailData.productionOrders[0].snPrefix,
        snLen:this.orderDetailData.productionOrders[0].snLen,
        startSn:this.orderDetailData.productionOrders[0].startSn,
        createSn:this.orderDetailData.productionOrders[0].createSn,
        battery:this.orderDetailData.productionOrders[0].battery,
        onlyCarton:this.orderDetailData.productionOrders[0].onlyCarton,
        tuyaPid:this.orderDetailData.productionOrders[0].tuyaPid,
      };
      
    },
    // 产品类别下拉
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
        const value = this.orderDetailData.productionOrders[0].productType.code;
        if (value) {
          this.getProductList(value, "addProductList");
        }
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 新建订单-产品类别改变
    addProductTypeChange(value) {
      this.$set(this.productForm, "productId", undefined);
      this.pullDownData.addProductList = [];
      if (value) {
        this.getProductList(value, "addProductList");
      }
    },
    // 步骤step点击
    stepClick(index) {
      if (index < this.productPagenum) {
        this.productPagenum = index;
      }
    },
    // 添加产品上一步
    preProductPage() {
      this.productPagenum--;
    },
    // 添加产品下一步
    nextProductPage() {
      this.$refs.productForm.validate(valid => {
        if (valid) {
          this.productPagenum++;
          // if (this.productPagenum == 1 && this.isEditProduct) {
          //   this.$nextTick(() => {
          //     this.$refs.fileInput.files =
          //       this.productForm.uuidFolder || this.productForm.uuidFile;
          //   });
          // }
        } else {
          return false;
        }
      });
    },
    // 新建订单-产品型号改变
    async productIdChange(value) {
      // this.swVersion = {
      //   mustIqc: true
      // };
      // this.mcuVersion = {};
      this.pullDownData.addProductList.forEach(item => {
        if (item.id == value) {
          this.p2pType = item.p2pType;
          this.$set(this.productForm, "tuyaPid", item.tuyaPid);
          if (item.p2pType != "DLink") {
            this.$set(this.productForm, "partNumber", undefined);
            this.$set(this.productForm, "pickSlip", undefined);
            this.$set(this.productForm, "hqPo", undefined);
          }
          this.wakeup = item.wakeup;
          if (!item.wakeup) {
            this.$set(this.productForm, "battery", undefined);
          }
        }
      });
      if (!value) return false;
      // this.getFirmwareList("Flash", "swVersionList");
      // this.getFirmwareList("MCU", "mcuVersionList");
    },
    // 输入框只能输入数字
    onlyNumber(value, formName, name) {
      this.$set(this[formName], name, this.$formatPositive(value));
    },
    // 输入框只能输入小数
    onlyDecimals(value, formName, name) {
      this.$set(this[formName], name, this.$formatDecimals(value));
    },
    // 创建时生成SN改变
    createSnChange(value) {
      if(value) return;
      this.$set(this.productForm, "snPrefix", "")
      this.$set(this.productForm, "snLen", "")
      this.$set(this.productForm, "startSn", "")
    },
    // 电量为整数,0-100
    minBattInput(value, formName, name) {
      // let newValue = this.$formatPositive(value);
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue > 100) {
        newValue = 100;
      } else if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, newValue);
    },
    // 电池容量
    batteryInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, newValue);
    },
    // 关闭添加产品
    closeCheckProduct() {
      this.productPagenum = 0;
      this.$refs.productForm.resetFields();
      this.productForm = {
        snPrefix: "AONI_",
        snLen: 5,
        onlyCarton: false,
        createSn: true
      };
      // this.swVersion = {
      //   mustIqc: true
      // };
      // this.mcuVersion = {};
    },
    // 确定添加产品
    checkProductSubmit() {
      this.$refs.productForm.validate(valid => {
        if (valid) {
          this.$confirm("确定完成该产品所有的配置信息吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.productionOrderAdd();
          });

          
        } else {
          return false;
        }
      });
    },

    productionOrderAdd(){
      this.$refs.productForm.validate(async valid => {
        if (valid) {
          const res = await apiAddProductionOrder({
                ...this.productForm
              });
              if (res.code == 0) {
                this.productionOrderVisible = false;
                //this.$refs.myDialog.dialogVisible = false;
                // 刷新详情页面
                this.dialogOpen();
                this.$message({
                  message: "新建成功",
                  type: "success"
                });
                
              } else if(res.code == 1024) {
                //this.$refs.myDialog.dialogVisible = false;
                this.$message({
                  message: res.msg,
                  type: "success"
                });
              }
        }
      });
    },

    // 修改确认按钮
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await apiCustomerOrderUpdate({
            ...this.editDetailForm
          });
          // console.log(res);
          if (res.code == 0) {
            this.innerVisible = false;
            this.$message({
              type: "success",
              message: "修改成功"
            });
            // 刷新详情页面
            this.dialogOpen();
            // 刷新表格数据
            this.$parent.getCustomerOrderSearch("noRemove");
          }
        } else {
          return false;
        }
      });
    },
    // 修改取消按钮
    resetForm(formName) {
      this.innerVisible = false;
      this.$refs[formName].resetFields();
      this.editDetailForm = {};
    },
    // 弹框选择
    selectVisible(value, orderName, labelName) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 弹框表格提交
    orderTableSubmit({ orderName, selectRow }) {
      if (orderName == "sales") {
        this.$set(this.editDetailForm, `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "AddList"}`, [selectRow]);
      }
    },
    callback() {
      this.getProductTypeList();
    }
  }
};
</script>

<style lang="less" scoped>
.productTable {
  /deep/.el-table__header-wrapper {
    line-height: 0;
    th {
      padding: 4px 0;
    }
  }
}
</style>